'use client';
import Image from 'next/image';
import Link from 'next/link';
import PortableText from '../../components/sanity/showBlogsDetails';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import OtpModal from '../modals/otpModal';
import useDetectMobileOS from '../../hooks/useDetectMobileOS';

const PostDisplay = ({ post, relatedPosts }) => {
    const otpModal = useSelector((state: RootState) => state.auth.otpModal);
    const os = useDetectMobileOS();

    if (!post) return <div>No post data</div>;

    return (
        <div className="mt-28 text-white container mx-auto px-4">
            {otpModal && <OtpModal />}
            <div className="lg:flex lg:gap-8">
                {/* Main Content */}
                <div className="lg:flex-1">
                    <h1 className="text-3xl text-center m-8">{post.title}</h1>
                    <img src={post.mainImage.asset.url} alt={post.title} className="inline-block w-full h-auto" />
                    <div className="grid grid-cols-2 py-5">
                        <div className="flex items-center">
                            <Image src={post.author.image.asset.url} alt={post.author.name} width={50} height={20} priority />
                            <div className="ml-3">{post.author.name}</div>


                        </div>
                        <div className="flex flex-col items-end text-gray-400">
                            {/* Date */}
                            <span>
                                {new Date(post.publishedAt).toLocaleDateString('en-IN', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                })}
                            </span>

                            {/* App Download Buttons (Minimal Spacing) */}
                            <div className="mt-1 flex space-x-2">
                                {os === 'Android' && (
                                    <Link target="_blank" href="https://play.google.com/store/apps/details?id=com.brightdigigold.customer" className="cursor-pointer">
                                        <Image
                                            src="https://brightdigigold.s3.ap-south-1.amazonaws.com/google-play-button.png"
                                            alt="Google Play button"
                                            width={140}
                                            height={50}  // Adjusted height for better fit
                                            priority
                                            sizes="(max-width: 100px) 100vw, 100px"
                                        />
                                    </Link>
                                )}

                                {os === 'iOS' && (
                                    <Link target="_blank" href="https://apps.apple.com/in/app/bright-digi-gold-buy-24k-gold/id1640972173" className="cursor-pointer">
                                        <Image
                                            src="https://brightdigigold.s3.ap-south-1.amazonaws.com/app-store-button+(2).png"
                                            width={140}
                                            height={50}  // Adjusted height for better fit
                                            alt="App Store button"
                                            priority
                                            sizes="(max-width: 100px) 100vw, 100px"
                                        />
                                    </Link>
                                )}

                                {os === 'Windows' && (
                                    <Link target="_blank" href="https://play.google.com/store/apps/details?id=com.brightdigigold.customer" className="cursor-pointer">
                                        <Image
                                            src="https://brightdigigold.s3.ap-south-1.amazonaws.com/google-play-button.png"
                                            alt="Google Play button"
                                            width={140}
                                            height={50}  // Adjusted height for better fit
                                            priority
                                            sizes="(max-width: 100px) 100vw, 100px"
                                        />
                                    </Link>
                                )}

                                {os === 'Mac' && (
                                    <Link target="_blank" href="https://apps.apple.com/in/app/bright-digi-gold-buy-24k-gold/id1640972173" className="cursor-pointer">
                                        <Image
                                            src="https://brightdigigold.s3.ap-south-1.amazonaws.com/app-store-button+(2).png"
                                            width={140}
                                            height={50}  // Adjusted height for better fit
                                            alt="App Store button"
                                            priority
                                            sizes="(max-width: 100px) 100vw, 100px"
                                        />
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='w-full sm:grid sm:grid-cols-6 gap-10'>
                        <div className='col-span-4'>
                            <div className="text-justify pb-4 text-xl poppins-medium prose prose-bold:mb-10 text-white">
                                {post.body && post.body.map((block, index) =>
                                    <PortableText key={index} content={block} />
                                )}
                            </div>
                        </div>
                        <div className='col-span-2'>
                            {/* Related Articles Section */}
                            <div className="sticky top-16">
                                <h2 className="text-2xl bold mx-4 text-center sm:mt-6">Read More Articles</h2>
                                <div>
                                    {relatedPosts.map((relatedPost, index) => (
                                        <Link key={index} href={`/digital-gold-blog/${relatedPost.slug.current}`} passHref>
                                            <div className="flex space-x-4  cursor-pointer py-3">
                                                <Image
                                                    src={relatedPost.thumbImage?.asset?.url}
                                                    alt={relatedPost.title}
                                                    width={160}
                                                    height={60}
                                                    className="rounded"
                                                />
                                                <p className="text-md text-white text-lg">{relatedPost.title}</p>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostDisplay;
